import apiRequest from "../../functions/api";

export const fetchTransferHistory = (client, accessToken) => {
    return new Promise((resolve, reject) => {
        const payload = {
            mandant: client,
            program: "GESEND",
            statement: "HISTORIE_HOLEN"
        };
        const headers = {
            Authorization: "Bearer " + accessToken,
        };
        apiRequest("POST", "daten", payload, headers, (response) => {
            if (response.status === 200) {
                resolve(response.data.belege);
              } else {
                if (response) {
                  reject(response.data.message);
                } else {
                  reject("Keine Internetverbindung");
                }
              }
            resolve();
        }, () => {
            reject("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
        });
    });
}